import Smartphones from 'Timesheet/views/TimesheetView/containers/Smartphones'
import Tablets from 'Timesheet/views/TimesheetView/containers/Tablets'

import {getCurrentDeviceView} from 'shared/helpers/utils'

const TimesheetView = getCurrentDeviceView(Smartphones, Tablets)

export default TimesheetView
